
import { defineComponent, onBeforeMount, PropType, reactive, toRefs } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import RepairItemTree
  from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-item-tree/repair-item-tree.vue'
import {
  SystemWrapperService
} from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-system-wrapper/system-wrapper.service'
import {
  BaseLineRepairDrawerService
} from '@/views/dashboard/safe-status/base-line/_components/baseLine-repair-drawer/baseLine-repair-drawer.service'
import {
  RepairItemTreeService
} from '@/views/dashboard/safe-status/base-line/_components/repair-item-drawer/repair-item-tree/repair-item-tree.service'
import {
  HandleType,
  HandleTypeUpdateFunctionMap,
  SystemTypeInjectionToken
} from '@/views/dashboard/safe-status/base-line/repair-item-tree-type'
import { BaseLineService } from '@/views/dashboard/safe-status/base-line/base-line.service'
import { ensureBaselineRepairItemsLoaded } from '@/views/dashboard/safe-status/base-line/baseline-repair-items-cache'
const HandleTypeMap = {
  1: 'autoIDs',
  2: 'notifyIDs',
  3: 'ignoreIDs'
}
export default defineComponent({
  props: {
    subIds: {
      type: Array as PropType<string[]>,
      default: () => ([] as string[])
    }
  },
  components: {
    RepairItemTree
  },
  setup (props) {
    const injector = useReflectiveInjector([BaseLineService, SystemWrapperService, {
      provide: SystemTypeInjectionToken,
      useValue: 1
    }, RepairItemTreeService, {
      provide: SystemTypeInjectionToken,
      useValue: 1
    }])
    const service = injector.get(SystemWrapperService)
    const parentService = injector.get(BaseLineRepairDrawerService)
    const data = reactive({
      autoIDs: [] as string[],
      notifyIDs: [] as string[],
      ignoreIDs: [] as string[]
    })
    function initData () {
      data.autoIDs = service.getTerminalAutoItemIds(props.subIds)
      data.notifyIDs = service.getTerminalNotifyItemIds(props.subIds)
      data.ignoreIDs = service.getTerminalIgnoreItemIds(props.subIds)
    }
    function updateTreeChange (oriType: HandleType, toType: HandleType, id:string) {
      data[HandleTypeMap[oriType]] = data[HandleTypeMap[oriType]].filter((sid: string) => sid !== id)
      data[HandleTypeMap[toType]].push(id)
      service[HandleTypeUpdateFunctionMap[oriType]](data[HandleTypeMap[oriType]])
      service[HandleTypeUpdateFunctionMap[toType]](data[HandleTypeMap[toType]])
      parentService.selectedWinIDs = {
        autoIDs: data.autoIDs,
        notifyIDs: data.notifyIDs,
        ignoreIDs: data.ignoreIDs
      }
    }
    onBeforeMount(async () => {
      await ensureBaselineRepairItemsLoaded(() => injector.get(BaseLineService).getAllBaselineItems())
      initData()
    })
    return {
      HandleType,
      updateTreeChange
    }
  }
})

